export enum FieldTypeConstants {
    Big,
    Medium,
    Small,
}